import { render, staticRenderFns } from "./QuestionnaireFormSectionGroup.vue?vue&type=template&id=531f307a&"
import script from "./QuestionnaireFormSectionGroup.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireFormSectionGroup.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireFormSectionGroup.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports